<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="etu_tempo"
      v-model="sasRegistreEtudiant.categorieDEtudiant"
      :live="liveSasRegistreEtudiant(5602)"
      @eudo-updated="updatePanier"
    />
    <CatalogueLive
      code="etu_parcours"
      v-model="sasRegistreEtudiant.parcoursChoisi"
      :live="liveSasRegistreEtudiant(5603)"
      :opq-if="estNon(sasRegistreEtudiant.categorieDEtudiant)"
      @eudo-updated="updatePanier"
    />
    <CatalogueLive code="etu_universite" v-model="sasRegistreEtudiant.universite" :live="liveSasRegistreEtudiant(5604)" />
    <TextFieldLive
      code="etu_univInt"
      v-model="sasRegistreEtudiant.ui_liveniversiteHorsCanada"
      :live="liveSasRegistreEtudiant(5605)"
      v-if="estHorsCanada(sasRegistreEtudiant.universite)"
    />
    <DatePickerLive
      code="etu_debut"
      v-model="sasRegistreEtudiant.dateDeDebut"
      :live="liveSasRegistreEtudiant(5606)"
      :opq-if="estNon(sasRegistreEtudiant.categorieDEtudiant)"
    />
    <DatePickerLive
      code="stage_debut"
      v-model="sasRegistreEtudiant.dateDeDebutDuStage"
      :live="liveSasRegistreEtudiant(5616)"
      :opq-if="estOui(sasRegistreEtudiant.categorieDEtudiant)"
    />
    <DatePickerLive
      code="stage_fin"
      v-model="sasRegistreEtudiant.dateDeFinDeStage"
      :live="liveSasRegistreEtudiant(5617)"
      :opq-if="estOui(sasRegistreEtudiant.categorieDEtudiant)"
    />
    <FileInput
      code="stage_lettre"
      :file="sasRegistreEtudiant.lettreDuMaitreDeStage"
      :live="liveSasRegistreEtudiant(5611)"
      :opq-if="estOui(sasRegistreEtudiant.categorieDEtudiant)"
      @file-deleted="sasRegistreEtudiant.lettreDuMaitreDeStage = null"
    />
    <FileInput
      code="stage_convention"
      :file="sasRegistreEtudiant.conventionDeStage"
      :live="liveSasRegistreEtudiant(5612)"
      :opq-if="estOui(sasRegistreEtudiant.categorieDEtudiant)"
      @file-deleted="sasRegistreEtudiant.conventionDeStage = null"
    />
  </v-form>
</template>


<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import { mapActions } from "vuex"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasRegistreEtudiant() {
      return this.sas.sasInscriptionRegistreEtudiant
    }
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({ endpoint: "demande-inscription-registre-etudiant", sasId: this.sas.id })
    },
    liveSasRegistreEtudiant(cle) {
      return { endpoint: "sas-inscription-etudiant", cle: cle, fileId: this.sasRegistreEtudiant.id }
    },
    estHorsCanada(universite) {
      return this.getCatalogueCodeById("5304", universite) == "20"
    }
  }
}
</script>

<style>
</style>